import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button, ConfigProvider, Form, Input, Modal, message, Skeleton, Dropdown, Menu } from "antd";
import {
  StarOutlined,
  VideoCameraAddOutlined,
  ShareAltOutlined,
  WhatsAppOutlined,
  TwitterOutlined,
  MailOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import Footer from "../Footer/Footer";
import TextArea from "antd/es/input/TextArea";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Topnav from "../TopNav/Topnav";
import Header from "../Header";

// Remove the problematic ShareButton import and create a simple share component
const SimpleShareButton = ({ url, title }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const shareOptions = [
    {
      key: 'whatsapp',
      label: 'WhatsApp',
      icon: <WhatsAppOutlined />,
      onClick: () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(title + ' ' + url)}`, '_blank');
        setDropdownVisible(false);
      }
    },
    {
      key: 'twitter',
      label: 'Twitter',
      icon: <TwitterOutlined />,
      onClick: () => {
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`, '_blank');
        setDropdownVisible(false);
      }
    },
    {
      key: 'email',
      label: 'Email',
      icon: <MailOutlined />,
      onClick: () => {
        window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`, '_blank');
        setDropdownVisible(false);
      }
    },
    {
      key: 'copy',
      label: 'Copy Link',
      icon: <LinkOutlined />,
      onClick: () => {
        navigator.clipboard.writeText(url);
        message.success('Link copied to clipboard!');
        setDropdownVisible(false);
      }
    }
  ];

  const menu = (
    <Menu items={shareOptions} />
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      open={dropdownVisible}
      onOpenChange={setDropdownVisible}
    >
      <PlayButton style={{ marginLeft: '10px' }}>
        <ShareAltOutlined /> Share
      </PlayButton>
    </Dropdown>
  );
};

const AgentAnchorDetails = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible1, setModalVisible1] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [form] = Form.useForm();
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const Token = localStorage.getItem("JwtToken");

  const handleVideoOpen = (index) => {
    setSelectedVideoIndex(index);
    setModalVisible2(true);
  };

  const handleOpenModal = (index) => {
    setSelectedImageIndex(index);
    setModalVisible(true);
  };

  const handleOpenModal1 = () => {
    setModalVisible1(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleCloseModal1 = () => {
    setModalVisible1(false);
  };

  const handleVideoClose = () => {
    setModalVisible2(false);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const headers = {
        'Content-Type': 'application/json',
      };

      if (Token) {
        headers['Authorization'] = `Bearer ${Token}`;
      }

      const response = await axios.get(
        `${API_URL}/api/agent-anchors/${id}?populate=*`,
        { headers }
      );
      
      const responseData = response?.data?.data;
      setDetails(responseData);
      console.log('Agent anchor details:', responseData);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching agent anchor details:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const res = await axios.post(`${API_URL}/api/hiring-models`, {
        data: {
          Name: values.yourName,
          MobileNumber: values.mobile,
          Email: values.emailId,
          Message: values.messages,
          agent_anchor: id
        }
      });
      message.success('Agent Anchor Request submitted successfully!');
      setModalVisible1(false);
      form.resetFields();
    } catch (error) {
      console.error(error);
      message.error('Failed to submit the Agent anchor request!');
    }
  };

  // Safe image URL function
  const getImageUrl = (imageData) => {
    if (!imageData) return '/placeholder-image.jpg';
    
    if (imageData.attributes?.url) {
      return `${API_URL}${imageData.attributes.url}`;
    }
    
    return '/placeholder-image.jpg';
  };

  const getThumbnailUrl = () => {
    const thumbnail = details?.attributes?.Thumbnail?.data;
    
    if (Array.isArray(thumbnail) && thumbnail.length > 0) {
      return getImageUrl(thumbnail[0]);
    }
    
    if (thumbnail?.attributes?.url) {
      return getImageUrl(thumbnail);
    }
    
    // Fallback to first image if thumbnail not available
    const images = details?.attributes?.Images?.data;
    if (images && images.length > 0) {
      return getImageUrl(images[0]);
    }
    
    return '/placeholder-image.jpg';
  };

  const url = window.location.href;
  const title = "Check this anchor out!";

  if (loading) {
    return (
      <>
        <Topnav />
        <Header />
        <Container>
          <Skeleton
            avatar
            paragraph={{
              rows: 4,
            }}
          />
        </Container>
      </>
    );
  }

  if (!details) {
    return (
      <>
        <Topnav />
        <Header />
        <Container>
          <div style={{ textAlign: 'center', padding: '50px', color: '#fff' }}>
            <h2>Agent Anchor not found</h2>
          </div>
        </Container>
      </>
    );
  }

  return (
    <>
      <Topnav />
      <Header />
      <Container>
        <Backdrop>
          <img
            alt="Backdrop"
            src={getThumbnailUrl()}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/placeholder-image.jpg';
            }}
          />
        </Backdrop>

        <DetailsContainer>
          <Title>{details?.attributes?.Name || "Agent Anchor"}</Title>
          <Lang>
            {details?.attributes?.Category || "Category not specified"}
            <span style={{ fontWeight: "bold", color: "red", fontSize: "1.5em", padding: '5px' }}>|</span>
            {details?.attributes?.Language || "Language not specified"}
          </Lang>

          <Look style={{ margin: "10px 0" }}>
            <span><StarOutlined /> Age: </span>
            {details?.attributes?.Age || "Not specified"}
          </Look>

          <Look style={{ margin: "10px 0" }}>
            <span><StarOutlined /> Specialization: </span>
            {details?.attributes?.Specialization || "Not specified"}
          </Look>

          <Look style={{ margin: "10px 0" }}>
            <span><StarOutlined /> Experience: </span>
            {details?.attributes?.Yearofexperience || details?.attributes?.Experience || "Not specified"}
          </Look>





          <Look style={{ margin: "10px 0" }}>
            <span><StarOutlined /> AgentAnchor_ID: </span>
            {details?.attributes?.agentAnchor_ID || "Not specified"}
          </Look>

          <Description>{details?.attributes?.Description || "No description available."}</Description>
          
          <div className="two-input" style={{ margin: "10px 0" }}>
            <PlayButton onClick={handleOpenModal1}>Hire me</PlayButton>
            <div>
              <SimpleShareButton url={url} title={title} />
            </div>
          </div>

          <Modal
            open={modalVisible1}
            onCancel={handleCloseModal1}
            footer={null}
            style={{ background: 'none' }}
          >
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#fba010",
                  colorText: "#ffffff",
                  colorIcon: "#ffffff",
                },
                components: {
                  Button: {
                    colorPrimary: "#e50914",
                    algorithm: true,
                    colorBgContainerDisabled: "#495057",
                  },
                  Form: {
                    colorPrimary: "#ffffff",
                    colorText: "#ffffff",
                    colorTextTertiary: "#ffffff",
                    colorTextSecondary: "#ffffff",
                    colorFillSecondary: "#ffffff",
                    algorithm: true,
                    labelColor: "#ffffff",
                  },
                  Typography: {
                    colorPrimary: "#ffffff",
                  },
                  Notification: {
                    colorBgElevated: "#212529",
                  },
                  Input: {
                    colorBgContainer: "#212529",
                    colorPrimary: "#fba010",
                    algorithm: true,
                    colorText: "#ffffff",
                    colorBorder: "#495057",
                    borderRadius: 0,
                  },
                },
              }}
            >
              <Form
                layout="vertical"
                size="large"
                className="form-container"
                style={{ padding: '20px' }}
                form={form}
              >
                <div className='two-input' style={{ justifyContent: 'space-between' }}>
                  <Form.Item
                    label="Your Name"
                    name="yourName"
                    rules={[{ required: true, message: 'Please Enter Your Name!' }]}
                    className="input-container"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Mobile Number"
                    name="mobile"
                    rules={[{ required: true, message: 'Please Enter Mobile Number!' }, { pattern: /^[0-9]{10}$/, message: 'Please Enter Valid Mobile Number!' }]}
                    className="input-container"
                  >
                    <Input />
                  </Form.Item>
                </div>
                <Form.Item
                  label="Email Address"
                  name="emailId"
                  rules={[{ required: true, message: 'Please Enter Your Email address!' }]}
                  className="input-container"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Your Message to our Anchor"
                  name="messages"
                  rules={[{ required: true, message: 'Please Describe your Message' }]}
                  className="input-container"
                >
                  <TextArea rows={5} />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" onClick={handleSubmit}>
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </ConfigProvider>
          </Modal>
        </DetailsContainer>
      </Container>

      {/* Images Section */}
      {details?.attributes?.Images?.data && details.attributes.Images.data.length > 0 && (
        <>
          <h1 style={{ textAlign: "center", marginTop: "40px" }}>
            <b style={{ color: "#e50914" }}>{details?.attributes?.Name}'s</b> Images
          </h1>
          <Container>
            <Content1>
              {details.attributes.Images.data.map((image, index) => (
                <div key={image.id || index}>
                  <div className="movieTrailers-container1">
                    <img
                      src={getImageUrl(image)}
                      onClick={() => handleOpenModal(index)}
                      alt={`Anchor ${index + 1}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/placeholder-image.jpg';
                      }}
                    />
                  </div>
                </div>
              ))}
            </Content1>
          </Container>

          {/* Image Modal */}
          <Modal
            open={modalVisible}
            onCancel={handleCloseModal}
            footer={null}
            className='Modal-Model'
            style={{
              overflowY: "hidden"
            }}
            bodyStyle={{
              padding: 0,
              margin: 0,
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Carousel
              selectedItem={selectedImageIndex}
              showThumbs={false}
              showStatus={false}
              infiniteLoop
              useKeyboardArrows
            >
              {details.attributes.Images.data.map((image) => (
                <div key={image.id} style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  <img
                    style={{
                      width: 'auto',
                      height: 'auto',
                      maxWidth: '100%',
                      maxHeight: '60vh',
                      objectFit: 'contain',
                    }}
                    className="AnchorImage"
                    src={getImageUrl(image)}
                    alt="Anchor"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/placeholder-image.jpg';
                    }}
                  />
                </div>
              ))}
            </Carousel>
          </Modal>
        </>
      )}

      {/* Videos Section */}
      {details?.attributes?.VideoFile?.data && details.attributes.VideoFile.data.length > 0 && (
        <>
          <h1 style={{ textAlign: "center", marginTop: "40px" }}>
            <b style={{ color: "#e50914" }}>{details?.attributes?.Name}'s</b> Videos
          </h1>
          <Container>
            <Content1>
              {details.attributes.VideoFile.data.map((video, index) => (
                <div key={video.id || index}>
                  <div className="movieTrailers-container1" onClick={() => handleVideoOpen(index)}>
                    <video style={{ height: '100%', width: '100%', objectFit: 'cover' }} controls muted>
                      <source src={getImageUrl(video)} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              ))}
            </Content1>
          </Container>

          {/* Video Modal */}
          <Modal
            open={modalVisible2}
            onCancel={handleVideoClose}
            footer={null}
            className='Modal-Model'
            style={{
              overflowY: "hidden"
            }}
            bodyStyle={{
              padding: 0,
              margin: 0,
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Carousel
              selectedItem={selectedVideoIndex}
              showThumbs={false}
              showStatus={false}
              infiniteLoop
              useKeyboardArrows
            >
              {details.attributes.VideoFile.data.map((video) => (
                <div key={video.id} style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  <video
                    style={{
                      width: 'auto',
                      height: 'auto',
                      maxWidth: '100%',
                      maxHeight: '60vh',
                      objectFit: 'contain',
                    }}
                    className="AnchorImage"
                    controls
                    autoPlay
                  >
                    <source src={getImageUrl(video)} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </Carousel>
          </Modal>
        </>
      )}

      <Footer />
    </>
  );
};

export default AgentAnchorDetails;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 calc(3.5vw + 5px);
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const PlayButton = styled.button`
  padding: 12px 20px;
  border-radius: 50px;
  cursor: pointer;
  border: 0;
  background-color: white;
  box-shadow: rgb(0 0 0 / 5%) 0 0 8px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-size: 15px;
  transition: all 0.5s ease;

  &:hover {
    letter-spacing: 3px;
    background-color: #e50914;
    color: hsl(0, 0%, 100%);
    box-shadow: #e50914 0px 7px 29px 0px;
  }
  &:active {
    letter-spacing: 3px;
    background-color: #e50914;
    color: hsl(0, 0%, 100%);
    box-shadow: #e50914 0px 0px 0px 0px;
    transform: translateY(10px);
    transition: 100ms;
  }

  @media (max-width: 768px) {
    padding: 10px 15px;
    font-size: 12px;
  }
`;

const Backdrop = styled.div`
  position: relative;
  flex: 0 0 60%;
  margin-right: 20px;
  max-width: 70%;
  max-height: 60vh;
  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 100%;
    margin-right: 0px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
`;

const Content1 = styled.div`
  cursor: pointer;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  img, video {
    width: 100%;
    height: 250px;
    object-fit: cover;
    opacity: 0.9;
    border-radius: 8px;
    transition: transform 0.3s ease;
    &:hover {
      transform: scale(1.05);
    }
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    grid-gap: 10px;
    img, video {
      height: 150px;
    }
  }
`;

const DetailsContainer = styled.div`
  flex: 0 0 40%;
  @media (max-width: 768px) {
    margin-top: 20px;
    font-size: 12px;
  }
`;

const Title = styled.h2`
  margin-bottom: 0px;
  text-transform: uppercase;
  color: #fff;
`;

const Description = styled.p`
  line-height: 1.4;
  color: #ccc;
`;

const Look = styled.p`
  line-height: 1;
  margin: 0;
  color: #fff;
  span {
    font-weight: bold;
    color: #e50914;
  }
`;

const Lang = styled.p`
  margin: 0;
  font-weight: bold;
  font-size: 1em;
  color: #fff;
  span {
    font-weight: bold;
    text-transform: uppercase;
  }
`;